import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { UserOnboardingRequest, UserOnboardingResource } from "../../../../shared/types/userOnboarding";

const baseKey = "user-onboarding";
const showKey = [baseKey];
const updateKey = [baseKey, "update"];

export const userOnboardingService = {
	showKey,
	show: () => axios.get<LaravelResponse<UserOnboardingResource>>(keyToUrl(showKey)),
	updateKey,
	update: (request: UserOnboardingRequest) => axios.put<UserOnboardingRequest>(keyToUrl(updateKey), request),
};
